import { useEffect, useState } from "react";

const NAV_LINKS = [
  { href: "#hot", label: "实时热榜" },
  { href: "#feature", label: "本期专题" },
  { href: "#grid", label: "事件档案" },
  { href: "#method", label: "梳理方法" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      {/* top utility strip — thick operations shell */}
      <div
        className={`hidden md:block bg-foreground-950 text-background-100 transition-opacity duration-300 ${
          scrolled ? "opacity-0 h-0 overflow-hidden" : "opacity-100"
        }`}
      >
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-2 text-xs text-background-200/90">
          <p className="flex items-center gap-2">
            <i className="ri-information-line text-accent-400" />
            本站仅对公开信息做中性的事件梳理与时间线还原，不产出主观定论。
          </p>
          <div className="flex items-center gap-4">
            <a href="#faq" className="hover:text-background-50 cursor-pointer">
              编辑准则
            </a>
            <span className="h-3 w-px bg-background-700" />
            <a href="#faq" className="flex items-center gap-1 hover:text-background-50 cursor-pointer">
              <i className="ri-flag-2-line" /> 内容纠错
            </a>
          </div>
        </div>
      </div>

      {/* main nav */}
      <div
        className={`border-b transition-all duration-300 ${
          scrolled
            ? "bg-background-50/90 backdrop-blur-md border-background-200 shadow-soft"
            : "bg-background-50/0 border-transparent"
        }`}
      >
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 md:px-6 py-3.5">
          <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-community-fill text-lg" />
            </span>
            <span className="font-heading text-xl md:text-2xl tracking-wide text-foreground-950">
              69吃瓜
            </span>
            <span className="mt-1 hidden rounded-full bg-accent-100 px-2 py-0.5 text-[10px] font-bold text-accent-800 sm:inline-block whitespace-nowrap">
              事件梳理站
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700 cursor-pointer"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-3 lg:flex">
            <a
              href="#hot"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600 cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-base" />
            </a>
            <a
              href="#faq"
              className="rounded-md bg-accent-500 px-4 py-2 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-accent-600 cursor-pointer"
            >
              我要投稿线索
            </a>
          </div>

          <button
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 lg:hidden cursor-pointer"
            aria-label="菜单"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
          </button>
        </div>

        {/* mobile menu */}
        {open && (
          <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 pb-4">
            <nav className="flex flex-col gap-1 py-3">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 cursor-pointer"
                >
                  {l.label}
                </a>
              ))}
            </nav>
            <a
              href="#faq"
              onClick={() => setOpen(false)}
              className="flex items-center justify-center rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-background-50 cursor-pointer"
            >
              我要投稿线索
            </a>
          </div>
        )}
      </div>
    </header>
  );
}